import { Action } from 'history';
import { AnyAction } from 'redux';
import { LOCATION_CHANGE } from 'redux-first-history';
import { Location } from 'src/modules/routing/types/Location';

export type LocationChangeAction = {
  readonly type: typeof LOCATION_CHANGE;
  readonly payload: {
    readonly location: Location;
    readonly action: Action;
  };
};

export function isLocationChangeAction(action: AnyAction): action is LocationChangeAction {
  return action.type === LOCATION_CHANGE;
}
